import React from 'react';
import Chip from 'Components/Chip';
import { colors } from 'Constants/Colors';

export default function DraftChip({ visible = true }) {
  if (visible === false) return null;

  return (
    <Chip style={{ background: colors.BLACK_50, border: 'none' }}>
      {null}
      <h4 style={{ color: 'white' }}>Borrador</h4>
    </Chip>
  );
}
